export const meta = {
  title: 'Terms of Service',
  description: 'Terms for using the independent fan guides and build planner.',
  updated_at: '2026-10-08',
};

## Independent Fan Resource

This site is not affiliated with Remedy Entertainment or the CONTROL rights holders. Game names and trademarks belong to their respective owners.

## Guides and Recommendations

Guides summarize facts checked against published sources. Recommendations are editorial judgments. Game updates may change behavior; inspect source links and verification dates.

## Build Planner

The tool records choices for reference. It does not modify game saves, calculate verified damage or guarantee results. Browser data can be deleted; keep important links yourself.

## Original Material and Third-party Rights

Site branding and puzzle diagrams are original fan-site material. Third-party linked content belongs to its owners. The site does not reproduce competitor screenshots or song lyrics.

## Availability

The service is provided as available. Features and content may change.

## Contact and Privacy

Contact [support@controlresonanttools.online](mailto:support@controlresonanttools.online). Read our [Privacy Policy](/privacy-policy) for storage and analytics information.
